import { useTranslation } from "react-i18next";

import { CircleCheckIcon, Loader2Icon, TriangleAlertIcon } from "lucide-react";

import { styled } from "simplydo/react/styled";
import { Icon } from "simplydo/react/ui/icon";
import { Message } from "simplydo/react/ui/message";

import type { IdentifierLookupState } from "./identifierLookup";

type IdentifierLookupStatusProps = { state: IdentifierLookupState };

const SpinningIcon = styled(Icon)`
  @keyframes identifier-lookup-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  animation: identifier-lookup-spin 0.8s linear infinite;
`;

export const IdentifierLookupStatus = ({
  state,
}: IdentifierLookupStatusProps) => {
  const { t } = useTranslation();

  if (state.status === "idle") {
    return null;
  }

  if (state.status === "pending") {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          marginTop: 8,
          color: "#666",
          fontSize: "0.9em",
        }}
      >
        <SpinningIcon icon={Loader2Icon} size="small" />
        {t("ideaBusinessProfiles.lookup.checking")}
      </div>
    );
  }

  if (state.status === "found") {
    return (
      <div style={{ marginTop: 8 }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            fontSize: "0.9em",
          }}
        >
          <Icon icon={CircleCheckIcon} color="green" size="small" />
          <span>
            {t("ideaBusinessProfiles.lookup.resolvedAs", { name: state.name })}
          </span>
        </div>
      </div>
    );
  }

  return (
    <Message color="orange" size="small" style={{ marginTop: 8 }}>
      <div style={{ display: "flex", alignItems: "flex-start", gap: 6 }}>
        <Icon icon={TriangleAlertIcon} size="small" />
        <span>{t("ideaBusinessProfiles.lookup.notFound")}</span>
      </div>
    </Message>
  );
};
